import React from 'react';

import guarantyData from '../../../constants/guarantyData';
import CloseIcon from '../../../assets/icons/closeModal.svg';
import ExchangeIcon from '../../../assets/icons/exchange.svg';
import GuarantyIcon from '../../../assets/icons/guaranty.svg';

import './Guarantee.scss';

interface IGuaranteeProps {
  onClose: () => void;
}

const Guarantee: React.FC<IGuaranteeProps> = ({ onClose }): JSX.Element => {
  return (
    <div className="guaranteeModal">
      <div className="guaranteeModal__top">
        <div className="guaranteeModal__wrapper">
          <div className="guaranteeModal__icon">
            <GuarantyIcon />
          </div>
          <div className="guaranteeModal__close" onClick={() => onClose()}>
            <CloseIcon />
          </div>
          <h2 className="guaranteeModal__title">{guarantyData[0].title}</h2>
          <p className="guaranteeModal__description">{guarantyData[0].description}</p>
        </div>
        <div className="guaranteeModal__wrapper">
          <div className="guaranteeModal__icon">
            <ExchangeIcon />
          </div>
          <h2 className="guaranteeModal__title">{guarantyData[1].title}</h2>
          <p className="guaranteeModal__description" dangerouslySetInnerHTML={{ __html: guarantyData[1].description }} />
        </div>
      </div>
      <div className="guaranteeModal__bottom">
        <div className="guaranteeModal__consult">
          <h2 className="guaranteeModal__consult-title">
            Всі питання, пов`язані з перевезенням і доставкою товару у Ваше місто, обговорюйте з нашими менеджерами за телефонами, вказаними
            нижче. Також пишіть нам через форму зворотного зв`язку на сайті
          </h2>
          <h3 className="guaranteeModal__consult-info">Контакти для замовлення та консультацій</h3>
          <div className="guaranteeModal__consult-items">
            <div className="guaranteeModal__consult-phone">
              <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M22.0742 15.7533C20.6049 15.7533 19.1621 15.5234 17.7949 15.0716C17.125 14.8431 16.3014 15.0528 15.8926 15.4727L13.194 17.5098C10.0644 15.8393 8.13669 13.9121 6.48894 10.8061L8.46612 8.17781C8.97981 7.66481 9.16406 6.91544 8.94331 6.21231C8.48956 4.83794 8.25906 3.39587 8.25906 1.92587C8.25913 0.863937 7.39519 0 6.33331 0H1.92581C0.863937 0 0 0.863937 0 1.92581C0 14.0977 9.90237 24 22.0742 24C23.1361 24 24.0001 23.1361 24.0001 22.0742V17.679C24 16.6172 23.1361 15.7533 22.0742 15.7533Z"
                  fill="#fed501"
                />
              </svg>
              <a href="tel:+380637300303" className="binct-phone-number-4">
                +380637300303
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Guarantee;
